<template>
  <div class="documentsDetail-box">
    <div class="detail-top">
      <div class="return-btn" @click="$router.push('/documentsList')" >
        返回列表
      </div>
    </div>
    <iframe frameborder="0" class="detail-bot" width="100%" height="500px" :src="docInfo.wsUrl"></iframe>
  </div>
</template>

<script>
export default {
  data () {
    return {
      docInfo: {}
    }
  },
  created () {
    this.docInfo = this.$route.query.item
    if (typeof (this.docInfo) === 'undefined') {
      this.$router.push('/documentsList')
    } else {
      this.docInfo = JSON.parse(this.docInfo)
      console.log(this.docInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
.documentsDetail-box{
  height: 100%;
  display: flex;
  flex-direction: column;
  .detail-top{
    padding: 10px 10px ;
    height: 50px;
    display: flex;
    justify-content: space-between;
    }
    .return-btn{
      width: 120px;
      height: 30px;
      line-height: 30px;
      display: inline-block;
      text-align: center;
      background: linear-gradient(90deg, #5A9CFF 0%, #4486FF 100%);
      box-shadow: 0px 2px 3px 0px rgba(76, 142, 255, 0.4);
      border-radius: 4px;
      border: 0;
      color: #fff;
      cursor: pointer;
   }
  }
  .detail-bot{
    flex: 1;
  }
</style>
